const COOKIE_NAME = 'carmenta_download_access';
const DOWNLOAD_FORM_IDS = [5, 6];

function setDownloadCookie() {
    const expiry = new Date();
    expiry.setFullYear(expiry.getFullYear() + 1);
    document.cookie = `${COOKIE_NAME}=1; path=/; expires=${expiry.toUTCString()}; SameSite=Lax`;
}

function getRisorseUrl() {
    return document.querySelector('[data-download-form]')?.dataset.risorseUrl || '';
}

function initFluentForms() {
    if (typeof FluentFormPublic !== 'undefined') {
        FluentFormPublic.init();
    }
}

function bindDownloadFormSuccess() {
    if (bindDownloadFormSuccess.bound || typeof jQuery === 'undefined') {
        return;
    }

    bindDownloadFormSuccess.bound = true;

    jQuery(document).on('fluentform_submission_success', function (event, data, form) {
        const $form = jQuery(form);
        const formId = parseInt($form.attr('data-form_id') || $form.data('form_id'), 10);

        if (!DOWNLOAD_FORM_IDS.includes(formId)) {
            return;
        }

        setDownloadCookie();

        const risorseUrl = getRisorseUrl();
        if (risorseUrl) {
            window.location.href = risorseUrl;
        }
    });
}

export function initDownloadArea() {
    bindDownloadFormSuccess();
    initFluentForms();
}
